<template>
  <div class="wrap">
    <div class="returnFunc">
      <el-button v-show="downloadExcelShow" class="lookUp" type="danger" @click="download"  icon="el-icon-download">下载</el-button>
      <el-button v-show="!downloadExcelShow" class="lookUp" type="warning" :loading="true" plain>下载..</el-button>
      <el-button plain @click="goBack">返回</el-button>
    </div>
    <div class="equiDetail">
      <el-backtop :visibility-height="200" :right="40" :bottom="80">
         <div class="el-icon-upload2"
            style="{
              height: 40px;
              width: 40px;
              background-color: #f2f5f6;
              borderRadius:50%;
              box-shadow: 0 0 6px rgba(0,0,0, .12);
              text-align: center;
              line-height: 40px;
            }"
        >
        </div>
      </el-backtop>
      <div class="equiMid_bottom">
        <div class="usetitle">
          <BorderTitle>{{ reportName }}</BorderTitle>
        </div>
        <div class="usetable">
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">设备名称</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.name }}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">设备编号</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.code }}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">设备类型</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.typeName }}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">所属组织</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.officeName }}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">设备型号</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.model==null?'-':Details.model }}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">品牌</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.brand==null?'-':Details.brand }}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isYaluji">
              <div class="itemLeft">吨位</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.tonnage==0||Details.tonnage==null||Details.tonnage==''?'-':Details.tonnage+' t' }}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isYaluji">
              <div class="itemLeft">前轮宽度</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.wheelHeadWidth==0||Details.wheelHeadWidth==null||Details.wheelHeadWidth==''?'-':Details.wheelHeadWidth+ ' m' }}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isTanpuji">
              <div class="itemLeft">熨平板宽度</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.wheelBackWidth==0||Details.wheelBackWidth==null||Details.wheelBackWidth==''?'-':Details.wheelBackWidth+' m'}}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isXibaoji"> <!--铣刨宽度未定义-->
              <div class="itemLeft">铣刨宽度</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.millingWidth==0||Details.millingWidth==null||Details.millingWidth==''?'-':Details.millingWidth+' mm'}}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isTanpuji || isXibaoji">
              <div class="itemLeft">设备负责人</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.leader==null?'-':Details.leader }}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1" v-if="isYaluji">
              <div class="itemLeft">后轮宽度</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.wheelBackWidth==0||Details.wheelBackWidth==null||Details.wheelBackWidth==''?'-':Details.wheelBackWidth+ ' m' }}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isYaluji">
              <div class="itemLeft">前后轮间隔</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.wheelGap==0||Details.wheelGap==null||Details.wheelGap==''?'-':Details.wheelGap+ ' m' }}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isYaluji">
              <div class="itemLeft">设备负责人</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.leader==null?'-':Details.leader }}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">设备联系电话</div>
              <div class="itemRight">
                <span class="infoShow">{{ Details.phone==null?'-':Details.phone }}</span>
              </div>
            </div>
            <div class="item_type1" v-if="isTanpuji || isXibaoji">
              <div class="itemLeft"></div>
              <div class="itemRight">
                <span class="infoShow"></span>
              </div>
            </div>
            <div class="item_type1" v-if="isTanpuji || isXibaoji">
              <div class="itemLeft"></div>
              <div class="itemRight">
                <span class="infoShow"></span>
              </div>
            </div>
            <div class="item_type1" v-if="isTanpuji || isXibaoji">
              <div class="itemLeft"></div>
              <div class="itemRight">
                <span class="infoShow"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="equiMid_bottom">
        <div class="usetitle">
          <BorderTitle>维修保养情况</BorderTitle>
        </div>
        <div class="usetable">
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">报告开始时间</div>
              <div class="itemRight">
                <span class="infoShow">{{ SituationVo.startTime }}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">报告结束时间</div>
              <div class="itemRight">
                <span class="infoShow">{{ SituationVo.endTime }}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">保养次数</div>
              <div class="itemRight">
                <span class="infoShow">{{ SituationVo.maintenanceTimes==null?'-':SituationVo.maintenanceTimes+"次"}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">保养总金额</div>
              <div class="itemRight">
                <span class="infoShow">{{ SituationVo.maintenanceMoney==null?'-':SituationVo.maintenanceMoney+"元"}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">平均保养时间间隔</div>
              <div class="itemRight">
                <span class="infoShow">{{ SituationVo.avgMaintenanceGapHour==null?'-':SituationVo.avgMaintenanceGapHour+"小时"}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">保养次数最多内容</div>
              <div class="itemRight">
                <span class="infoShow">{{SituationVo.maxMaintenanceTimesContent==null?'-':SituationVo.maxMaintenanceTimesContent+'('+(SituationVo.maxMaintenanceTimes==null?'-':SituationVo.maxMaintenanceTimes)+'次)'}}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">维修次数</div>
              <div class="itemRight">
                <span class="infoShow">{{SituationVo.repairTimes==null?'-':SituationVo.repairTimes+"次"}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">维修总金额</div>
              <div class="itemRight">
                <span class="infoShow">{{SituationVo.repairMoney==null?'-':SituationVo.repairMoney+"元"}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">平均维修金额</div>
              <div class="itemRight">
                <span class="infoShow">{{SituationVo.avgRepairMoney==null?'-':SituationVo.avgRepairMoney+"元/次"}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">维修次数最多内容</div>
              <div class="itemRight">
                <span class="infoShow">{{SituationVo.maxRepairTimesContent==null?'-':SituationVo.maxRepairTimesContent+'('+(SituationVo.maxRepairTimes==null?'-':SituationVo.maxRepairTimes)+'次)'}}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="usetitle1">
          <span class="title">维修保养记录</span>
          <span class="shouqi" ref="cares" @click="shouqiFun($refs.care,$refs.cares,$refs.carez,'shouqi')">收起<i class="el-icon-d-arrow-left" style="transform:rotate(90deg);marginLeft:5px"></i></span>
          <span class="shouqi" ref="carez" @click="shouqiFun($refs.care,$refs.cares,$refs.carez,'zhankai')">展开<i class="el-icon-d-arrow-right" style="transform:rotate(90deg);marginLeft:5px"></i></span>
        </div>
        <el-collapse-transition>
        <div class="unitablelist" ref="care">
          <el-table
            :data="Maintenance"
            style="width: 100%"
            size="medium"
          >
          <el-table-column
            prop="order"
            label="序号"
            min-width="3.82837033%"
          ></el-table-column>
          <el-table-column
            prop="maintenanceContent"
            label="维保内容"
            min-width="10.2425554%"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            min-width="6.2425554%"
          >
          <template slot-scope="scope">
            <span class="" v-if="scope.row.type == 0">保养</span>
            <span class="" v-if="scope.row.type == 1">维修</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="maintenanceTime"
            label="维保时间"
            min-width="12.95289658%"
          ></el-table-column>
          <el-table-column
            prop="time"
            label="本次保养小时"
            min-width="10.95289658%"
          >
          <template slot-scope="scope">
            <span class="" v-if="scope.row.type == 0">{{scope.row.time}}</span>
            <span class="" v-if="scope.row.type == 1">-</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="planTime"
            label="计划下次保养小时"
            min-width="10.95289658%"
          >
          <template slot-scope="scope">
            <span class="" v-if="scope.row.type == 0">{{scope.row.planTime}}</span>
            <span class="" v-if="scope.row.type == 1">-</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="money"
            label="维保金额（元）"
            min-width="10.95289658%"
          ></el-table-column>
          <el-table-column
            prop="operator"
            label="维保负责人"
            min-width="8.2425554%"
          ></el-table-column>
          <el-table-column
            prop="contact"
            label="维保联系电话"
            min-width="8.2425554%"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            min-width="16.2425554%"
          ></el-table-column>
          </el-table>
        </div>
        </el-collapse-transition>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getEquipMaintenanceReport,exportPdfEquipMaintenanceReport } from "../../utils/api";
import { toChineseDate,getDateSeconds } from "../../utils/commons";
import BorderTitle from "../../components/common/borderTitle";
import { Loading } from 'element-ui';
import { Message} from 'element-ui';
export default {
  name: "app",
  data() {
    return {
      typeName: "",
      reportName:'',
      code: "",
      value1:[],
      isTanpuji: false, //是否为摊铺机
      isYaluji:false,
      isXibaoji:false,
      Details: {},
      SituationVo: {},
      EquipUsage: [],
      Refuel: [],
      Maintenance: [],
      Warning: [],
      loadingInstance: '',
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "报告管理",
          path: "/transfer/wordList",
        },
        {
          name: "维修保养报告",
          path: "/transfer/equipmentCareReport",
        },
      ],
      downloadExcelShow: true,
    };
  },
  // props:["isTanpuji"],
  computed: {},
  components: { BorderTitle },
  created() {},
  mounted() {
    window.scrollTo(0,0);
    this.code = this.$route.query.code
    this.reportName = this.$route.query.name
    this.$store.commit("setArrowList", this.arrowList);
    this.value1=[this.$route.query.startTime+" 00:00:00",this.$route.query.endTime+" 23:59:59"]
    let params = {
      code: this.code,
      startTime: this.value1[0],
      endTime: this.value1[1]
    };
    console.log(params, "codecode");
    this.getEquipUseTable(params);
    this.$refs.carez.style.display='none'
  },
  methods: {
    //展开收起函数
    shouqiFun(p,c1,c2,type){
      if(type=='shouqi'){
        p.style.display='none'
        c1.style.display='none'
        c2.style.display='inline'
      }else if(type=='zhankai'){
        p.style.display='block'
        c1.style.display='inline'
        c2.style.display='none'
      }
    },
    async download() { // 下载使用说明书
      let userRoleList = localStorage.getItem("userRoleList")
      if(userRoleList.indexOf("menu-9e0227c771f847899331d163de724437") < 0){
        Message.error('您没有权限，可联系管理员添加权限！')
        return
      }
      this.downloadExcelShow = false
      this.loadingInstance = Loading.service({text:'下载中...'});
      let params = {
        code: this.code,
        startTime: this.value1[0],
        endTime: this.value1[1],
      };
      const InstructionManualvv = await exportPdfEquipMaintenanceReport(params);
      let blob = new Blob([InstructionManualvv.data], {type: 'application/pdf;charset=UTF-8'});
      let fileName = this.Details.name+'使用报告'+getDateSeconds()+'.pdf';
      if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
      } else {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href) //释放内存
      }
      this.downloadExcelShow = true
      this.loadingInstance.close();
    },
    // download(){
    //   let params = {
    //     code: this.code,
    //     startTime: this.value1[0]+" 00:00:00",
    //     endTime: this.value1[1]+" 23:59:59",
    //   };
    //   exportPdfEquipMaintenanceReport(params)
    // },
    // confirm(){
    //   let params = {
    //     code: this.code,
    //     startTime: this.value1[0]+" 00:00:00",
    //     endTime: this.value1[1]+" 23:59:59",
    //   };
    //   this.getEquipUseTable(params);
    // },
    // reset(){
    //   this.value1=[dateTransfor1()+" 00:00:00",dateTransfor()+" 23:59:59"];
    //   let params = {
    //     code: this.code,
    //     startTime: this.value1[0]+" 00:00:00",
    //     endTime: this.value1[1]+" 23:59:59",
    //   };
    //   console.log(params, "codecode");
    //   this.getEquipUseTable(params);
    // },
    goBack() {
      this.$router.go(-1);
    },
    getEquipUseTable(params) {
      this.loadingInstance = Loading.service({});
      getEquipMaintenanceReport(params).then((res) => {
        console.log(params, res);
        this.Details = res.data.content.info.sysEquipDetails;
        if(this.Details.typeName==null){
          if (this.Details.name.includes("摊铺")) {
            this.isTanpuji = true;
          } else if (this.Details.name.includes("压路")) {
            this.isYaluji = true;
          }else{
            this.isXibaoji = true;
          }
        }else{
          if (this.Details.typeName.includes("摊铺")) {
            this.isTanpuji = true;
          } else if (this.Details.typeName.includes("压路")) {
            this.isYaluji = true;
          }else{
            this.isXibaoji = true;
          }
        }
        this.SituationVo = res.data.content.info.equipMaintenanceInfo;
        this.SituationVo.startTime = this.dateTrans1(
          this.SituationVo.startTime
        );
        this.SituationVo.endTime = this.dateTrans1(this.SituationVo.endTime);
        this.Maintenance = res.data.content.info.recordMaintenancePage.list;
        this.Maintenance.map((item, index) => {
          item.order = '  '+(index + 1);
          item.maintenanceTime=item.maintenanceTime==null?'':toChineseDate(item.maintenanceTime);
        });
        this.loadingInstance.close();
      });
    },
    dateTrans1(date) {
      return (
        date.slice(0, 4) +
        "年" +
        date.slice(5, 7) +
        "月" +
        date.slice(8, 10) +
        "日"
      );
    },
    // dateTrans2(date){
    //   return date.slice(0,3)+"年"+date.slice(5,6)+"月"+date.slice(8,9)+"日";
    // }
  },
  watch: {
    typeName(val) {
      if (val.includes("摊铺机")) {
        this.isTanpuji = true;
      } else {
        this.isTanpuji = false;
      }
    },
  },
  beforeDestroy(){
    this.loadingInstance.close();
  }
};
</script>
<style lang='scss'>
  .unitablelist{
        .el-table__header tr th {
        background-color:#EBEBEC !important;
        padding: 3px 0px !important;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555 !important;
        height: 36px;
        }
}
</style>
<style lang="scss" scoped="">
.wrap {
  width: 98.5%;
  height: auto;
  padding-bottom: 21px;
  margin: 0 auto;
  margin-bottom: 29px;
  .returnFunc {
    position: fixed;
    top: 65px;
    right: 15px;
    z-index: 1000;
  }

  .equiDetail {
    width: 100%;
    margin: 0 auto;
    // overflow-y: scroll;
    height: 400px;
    .equiMid_bottom {
      display: flex;
      background: #ffffff;
      padding: 18px;
      margin-bottom: 12px;
      flex-direction: column;
      border: 1px solid rgba(225, 225, 225, 1);
      .usetitle {
        height: 40px;
        margin-left: 5px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #222222;
        line-height: 24px;
      }
      .usetable {
        border-top: 1px solid rgba(225, 225, 225, 1);
        border-left: 1px solid rgba(225, 225, 225, 1);
        .blockItem {
          display: flex;
          height: 41px;
          .item_type1 {
            flex: 1;
          }
          .item_type2 {
            flex: 2;
          }
          .item_type3 {
            flex: auto;
            text-align: center;
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);
            line-height: 40px;
            font-weight: bolder;
          }
          .title2 {
            color: #ffffff;
            background: #e96b5a;
            border: none;
          }
          .itemLeft {
            width: 130px;
            height: 40px;
            float: left;
            background: rgba(242, 242, 245, 1);
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);
            line-height: 40px;
            padding-left: 10px;
            color: #555555;
            font-size: 14px;
          }
          .itemLeft1 {
            width: 152px;
            height: 40px;
            float: left;
            background: rgba(242, 242, 245, 1);
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);
            line-height: 40px;
            padding-left: 15px;
            color: #555555;
            font-size: 14px;
          }
          .itemRight {
            // width: 100%;
            height: 40px;
            line-height: 40px;
            padding-left: 15px;
            color: #555555;
            font-size: 14px;

            overflow: hidden;
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);
            .infoShow {
              width: 100%;
              height: 100%;
              border: 0;
              color: #555555;
              font-size: 14px;
            }
          }
        }
      }
      .usetitle1 {
        height: 50px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        color: #555555;
        line-height: 50px;
        margin-top: 18px;
        margin-bottom: 12px;
        background: #f2f2f5;
        border: 1px solid #e1e1e1;
        display: flex;
        justify-content: space-between;
        .title{
          padding-left: 15px;
          font-weight: bold;
        }
        .shouqi{
          padding-right: 15px;
          cursor: pointer;
        }
      }
    }
  }
}

</style>